import { CancelIcon } from '@checkit/react-components/build/components/Icons';
import { Button, makeStyles, Toolbar } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Location } from 'history';
import React, {FC} from 'react';
import { useIntl } from 'react-intl';
import { SaveIcon } from '../../../common/SaveIcon';
import MaterialUiLink from '../../../components/MaterialUiLink';
import { appMessages } from '../../../translations';

interface Props {
  to: Location;
  formSubmitting: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    margin: theme.spacing(1)
  },
  formInput: {
    marginTop: theme.spacing(3)
  },
  iconSmall: {
    fontSize: 20
  },
  leftIcon: {
    marginRight: theme.spacing(1)
  },
  toolBar: {
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center'
    },
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3)
  }
}));

export const FormToolbar: FC<Props> = (props: Props) => {
  const {to, formSubmitting} = props;
  const {formatMessage} = useIntl();
  const classes = useStyles();

  return (
    <Toolbar className={classes.toolBar}>
      <Button
        variant="contained"
        color="secondary"
        className={classes.button}
        component={MaterialUiLink}
        to={to}
      >
        <CancelIcon className={clsx(classes.leftIcon, classes.iconSmall)}/>
        {formatMessage(appMessages['app.cancel'])}
      </Button>
      <Button
        variant="contained"
        color="primary"
        type="submit"
        className={classes.button}
        disabled={formSubmitting}
      >
        <SaveIcon formSubmitting={formSubmitting} />
        {formatMessage(appMessages['app.save'])}
      </Button>
    </Toolbar>
  );
};
